<div class="flex h-screen flex-col rtl:flex-row-reverse">
  <IToasterList />

  <div class="flex w-full flex-col">
    @if (globalWarning()) {
      <div class="bg-destructive/10 text-destructive top-banner">
        {{ globalWarning() }}
      </div>
    }
    @if (environmentService.showDemoEnvWarning) {
      <div class="bg-warning top-banner">
        <div class="text-white">
          <span>Demo environment</span>
          <span> • Logged from Board Admin</span>
        </div>
        <button iButton variant="secondary" (click)="environmentService.printDebugInfo()">Debug Info</button>
      </div>
    }
    @if (environmentService.showProdEnvWarning) {
      <div class="bg-destructive top-banner">
        <div class="text-white">
          <span>Production environment</span>
          <span> • Logged from Board Admin</span>
        </div>
        <button iButton variant="secondary" (click)="environmentService.printDebugInfo()">Debug Info</button>
      </div>
    }
    @if (productTour()) {
      <div *transloco="let t" class="type-body top-banner bg-(--top-banner-info)">
        <div class="flex items-center gap-2 text-white">
          <IIcon name="infoCircle" />
          <span>{{ t("default-layout.product_tour_banner") }}</span>
        </div>
        <a iButton variant="secondary" size="sm" [href]="autopilotUrl">{{ t("default-layout.back_to_autopilot") }}</a>
      </div>
    }
  </div>

  <div class="flex min-h-0 w-full flex-1" id="main">
    <app-board-sidebar />
    <div class="flex-1 overflow-auto">
      <app-page-layout><router-outlet /></app-page-layout>
    </div>
  </div>
</div>
